import { render, staticRenderFns } from "./user-page.vue?vue&type=template&id=22e49b98"
import script from "./user-page.vue?vue&type=script&lang=js"
export * from "./user-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports